// extracted by mini-css-extract-plugin
export default {"Embed__Youtube":"styles__Embed__Youtube__T4h7W"};